import { useEffect } from 'react';
import styled from 'styled-components';
import { PaginationFooter } from 'ui/paginationFooter';
import { colors } from 'ui/theme';
import { ListReferenceRow } from './ListReferenceRow';
import { Table } from './table/Table';
import { HeaderRow } from './table/HeaderRow';
import { ResultsTableSkeleton } from '../ResultsTableSkeleton';
import { NoResultsEmptyState } from '../NoResultsEmptyState';
import { useListReferencesContext } from '../../../contexts/listReferences';
import { AudienceInsightsErrorBoundary } from '../../../contexts/errorBoundary';
import { useTranslation } from '../../../hooks';
import { FETCH_REFERENCES_TRIGGER } from './constants';

const Wrapper = styled.div`
  background-color: ${colors.backgroundPrimary};
  height: 100%;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const testIds = {
  footer: 'segmentation-lr-footer',
  tableWrapper: 'segmentation-lr-table-wrapper',
  wrapper: 'segmentation-lr-wrapper',
};

export const ListReferencesTableContent = () => {
  const { t } = useTranslation();
  const {
    creatorsAndModifiersById,
    currentPage,
    isError,
    isLoading,
    listReferences,
    fetch,
    fetchCreatorsAndModifiers,
    pageSize,
    setCurrentPage,
    setPageSize,
    totalCount,
  } = useListReferencesContext();

  useEffect(() => {
    fetch(FETCH_REFERENCES_TRIGGER.INSIGHTS);
    fetchCreatorsAndModifiers();
  }, []);

  const hasResults = !!totalCount && !isLoading;

  const getListReferencesTableContent = () =>
    hasResults ? (
      <>
        <TableWrapper data-test={testIds.tableWrapper}>
          <Table>
            <HeaderRow />
            {listReferences.map((listReference, index) => (
              <ListReferenceRow
                listReference={listReference}
                key={`usage: ${listReference.id}- ${listReference.createdAt}`}
                index={index}
                creatorsAndModifiersById={creatorsAndModifiersById}
              />
            ))}
          </Table>
        </TableWrapper>
        <PaginationFooter
          data-test={testIds.footer}
          currentPage={currentPage}
          itemsPerPage={pageSize}
          numItems={totalCount}
          onUpdate={({ page, pageSize: newPageSize }) => {
            setCurrentPage(page);
            setPageSize(newPageSize);
          }}
        />
      </>
    ) : (
      <NoResultsEmptyState
        title={t('emptyState.references.title')}
        subtitle={t(`emptyState.references.${isError ? 'error' : 'subtitle'}`)}
      />
    );

  return (
    <Wrapper data-test={testIds.wrapper}>
      {isLoading ? <ResultsTableSkeleton numColumns={4} /> : getListReferencesTableContent()}
    </Wrapper>
  );
};

export const ListReferencesTable = () => (
  <AudienceInsightsErrorBoundary>
    <ListReferencesTableContent />
  </AudienceInsightsErrorBoundary>
);
